import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
//
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DialogToastComponent } from './dialogs/dialog-toast/dialog-toast.component';
import { DialogSpinnerComponent } from './dialogs/dialog-spinner/dialog-spinner.component';
import { DialogPromptComponent } from './dialogs/dialog-prompt/dialog-prompt.component';
import { DialogConfirmComponent } from './dialogs/dialog-confirm/dialog-confirm.component';
import { DialogAlertComponent } from './dialogs/dialog-alert/dialog-alert.component';
import { DialogTitleComponent } from './dialogs/dialog-title/dialog-title.component';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import {
	MAT_TOOLTIP_DEFAULT_OPTIONS,
	MatTooltipDefaultOptions
} from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
	declarations: [
		// DIALOGS
		DialogTitleComponent,
		DialogAlertComponent,
		DialogConfirmComponent,
		DialogPromptComponent,
		DialogSpinnerComponent,
		DialogToastComponent
	],
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		TranslateModule,
		// MATERIALIZE
		MatButtonModule,
		MatFormFieldModule,
		MatIconModule,
		MatInputModule,
		MatProgressSpinnerModule,
		MatDialogModule,
		MatCardModule,
		MatMenuModule
	],
	exports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		TranslateModule,
		// MATERIALIZE
		MatButtonModule,
		MatFormFieldModule,
		MatIconModule,
		MatInputModule,
		MatProgressSpinnerModule,
		MatDialogModule,
		MatCardModule,
		MatMenuModule,
		// COMPONENTS
		DialogTitleComponent
	],
	providers: [
		{
			provide: MAT_TOOLTIP_DEFAULT_OPTIONS,
			useValue: {
				showDelay: 750,
				position: 'before',
				hideDelay: 0,
				disableTooltipInteractivity: true
			} as MatTooltipDefaultOptions
		}
	]
})
export class CoreModule {}
